module.exports = __webpack_public_path__ + "img/play.f3515a9c.png";